const baseServer = process.env.VUE_APP_API_URL;

export default {
    servicioURL: baseServer,
    servicioApi: baseServer + '/api',
}